var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 8.4751L1.45451 16.3501L0.125 14.9392L6.24691 8.4751L0.155918 2.01104L1.48542 0.600099L8.875 8.4751Z",
    fill: "url(#paint0_linear_1152_45698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 8.4751L11.4545 16.3501L10.125 14.9392L16.2469 8.4751L10.1559 2.01104L11.4854 0.600099L18.875 8.4751Z",
    fill: "url(#paint1_linear_1152_45698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1152_45698",
    x1: 0.125,
    y1: 8.4751,
    x2: 8.875,
    y2: 8.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1152_45698",
    x1: 10.125,
    y1: 8.4751,
    x2: 18.875,
    y2: 8.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEnd);
export default __webpack_public_path__ + "static/media/button-end.4752895f015d38b4e825b0b59e6b1685.svg";
export { ForwardRef as ReactComponent };